import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortDown1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 748,
	height: 423,
	viewBox: "0 0 748 423",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.7973 99.0795C-5.54389 71.6913 -20.5557 0.114835 68.9031 0.114839L680.103 0.114865C766.644 0.114869 754.55 71.6913 727.162 99.0796L424.009 402.327C396.668 429.621 352.385 429.621 324.997 402.327L21.7973 99.0795Z",
		fill: "#000"
	})
});
export default SvgSortDown1;
